export default {
  setCosts(state, payload) {
    state.costs = payload;
  }
}
